<span class="w-full wrapper">
    @if (showLabel()) {
        <app-float-label>
            @if (icon()) {
                <p-iconfield [iconPosition]="iconPosition()">
                    @if (iconPosition() === 'left') {
                        <p-inputicon>
                            <app-icon [icon]="icon()"></app-icon>
                        </p-inputicon>
                    }

                    <ng-container *ngTemplateOutlet="inputField"></ng-container>

                    @if (iconPosition() === 'right') {
                        <p-inputicon>
                            <app-icon [icon]="icon()"></app-icon>
                        </p-inputicon>
                    }
                </p-iconfield>
            } @else {
                <ng-container *ngTemplateOutlet="inputField"></ng-container>
            }
            @if (clear() && value()) {
                <app-icon class="p-inputicon clear" icon="pi-times" (onClick)="clearInput()"></app-icon>
            }
            <label [for]="id()">{{ label() | translate }}</label>
        </app-float-label>
    } @else {
        @if (icon()) {
            <p-iconfield [iconPosition]="iconPosition()">
                @if (iconPosition() === 'left') {
                    <p-inputicon>
                            <app-icon [icon]="icon()"></app-icon>
                    </p-inputicon>
                }

                <ng-container *ngTemplateOutlet="inputField"></ng-container>

                @if (iconPosition() === 'right') {
                    <p-inputicon>
                        <app-icon [icon]="icon()"></app-icon>
                    </p-inputicon>
                }
            </p-iconfield>
        } @else {
            <ng-container *ngTemplateOutlet="inputField"></ng-container>
        }
        @if (clear() && value()) {
            <app-icon class="p-inputicon clear" icon="pi-times" (onClick)="clearInput()"></app-icon>
        }
    }

    <ng-template #inputField>
        @if (uppercaseActive()) {
            <input #inputElement
                uppercase
                [id]="id()"
                [(ngModel)]="value"
                [disabled]="disabled()"
                [type]="type"
                [attr.placeholder]="placeholder() ?? null"
                [readonly]="readonly()"
                [invalid]="isInvalid()"
                [attr.aria-describedby]="id() + '-help'"
                [autocomplete]="autocomplete() ? 'on' : 'off'"
                [maxlength]="maxLength()"
                pInputText
                class="w-full"
                [class.p-filled]="filled()"
                [ngClass]="{ 'p-disabled': disabled(), 'required-input-border': required() }"
                (blur)="touch.emit()"
            />
        } @else {
            <input #inputElement
                [id]="id()"
                [(ngModel)]="value"
                [disabled]="disabled()"
                [type]="type"
                [attr.placeholder]="placeholder() ?? null"
                [readonly]="readonly()"
                [attr.aria-describedby]="id() + '-help'"
                [autocomplete]="autocomplete() ? 'on' : 'off'"
                [maxlength]="maxLength()"
                pInputText
                class="w-full"
                [class.p-filled]="filled()"
                [ngClass]="{ 'p-disabled': disabled(), 'required-input-border': required() }"
                (blur)="touch.emit()"
            />
        }
    </ng-template>
</span>
@if (showHelpText()) {
    <small>{{ helpText() | translate }}</small>
}
<app-input-error [errors]="errors()" [touched]="touched()"></app-input-error>
